import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

interface UserInvitedWizardScreenProps {
  onClose: () => void;
}

export const UserInvitedWizardScreen = ({ onClose }: UserInvitedWizardScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'common.success_invite_sent',
          defaultMessage: 'Success - your invite has been sent!'
        })}
      />
    </WizardScreen>
  );
};
